import styled from 'styled-components';

export const ChangesItemContainer = styled.div`
  .changes-item-title {
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    margin-top: ${({ theme: { token } }) => token.marginXS}px;
  }
`;
